import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useHistory } from 'react-router-dom';
import '../404/Page404.scss';
import { AnimatedIcon } from '../../components/commons/AnimatedIcon';
import QuestionIconLight from '../../assets/images/lottieIcons/question/question.light.json';
import QuestionIconDark from '../../assets/images/lottieIcons/question/question.dark.json';
import { CustomMUIButton } from '../../components/commons/buttons/CustomMUIButton';
import { ButtonClassNames, GlobalRouteNames } from '../../models/Common';

export const ErrorPage = () => {
  const { t } = useTranslation();
  const { state }: { state: { message?: string } } = useLocation();
  const history = useHistory();

  const handleButton = () => {
    history.replace(GlobalRouteNames.HomePage);
  };

  return (
    <div className="page-404 page">
      <div className="page-404__container container">
        <AnimatedIcon lightIcon={QuestionIconLight} darkIcon={QuestionIconDark} className="page-404__icon" />
        <div className="page-404__content">
          <h1>{t('404.errorOccurred')}</h1>
          <div className="page-404__content__text-btn-container">
            <p>{state?.message ? t(state.message) : t('404.tryAgainLater')}</p>
            <CustomMUIButton
              label={t('buttons.toMain')}
              handleClick={handleButton}
              className={ButtonClassNames.PrimaryFulfilled}
              isBold
            />
          </div>
        </div>
      </div>
    </div>
  );
};
